"use client";

import { ReactNode } from "react";
import { AuthProvider } from "../context/AuthContext";
import { ProductProvider } from "../context/ProductContext";
import { CartProvider } from "../context/CartContext";
import { Toaster } from "react-hot-toast";

export function StorefrontProviders({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <ProductProvider>
        <CartProvider>
          {children}
          <Toaster />
        </CartProvider>
      </ProductProvider>
    </AuthProvider>
  );
}
